import React, { useState } from 'react';
import { Tag, Loader2, X, Check } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { promosAPI } from '../services/api';
import { useT } from '../services/i18n';

const PromoCodeField = ({ promo, onChange, disabled }) => {
  const { t } = useT();
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true); setError('');
    try {
      onChange(await promosAPI.validate(code));
      setCode('');
    } catch (e) {
      setError(e.response?.data?.detail || t('promo.invalid'));
    } finally {
      setBusy(false);
    }
  };

  if (promo) {
    return (
      <div className="flex items-center justify-between gap-2 bg-green-50 border border-green-200 rounded-lg px-3 py-2" data-testid="promo-applied">
        <p className="text-sm text-green-800 flex items-center gap-2"><Check size={15} /> <span><strong>{promo.code}</strong> · {promo.label}{promo.description ? <span className="text-green-700"> — {promo.description}</span> : ''}</span></p>
        {!disabled && <button type="button" onClick={() => onChange(null)} data-testid="promo-remove" className="text-green-700 hover:text-red-600" title={t('promo.remove')}><X size={16} /></button>}
      </div>
    );
  }
  return (
    <div data-testid="promo-field">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Tag size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <Input data-testid="promo-input" value={code} onChange={(e) => { setCode(e.target.value.toUpperCase()); setError(''); }} onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), apply())} placeholder={t('promo.placeholder')} className="pl-9 uppercase" disabled={disabled} />
        </div>
        <Button type="button" variant="outline" onClick={apply} disabled={busy || disabled || !code.trim()} data-testid="promo-apply">{busy ? <Loader2 size={14} className="animate-spin" /> : t('common.apply')}</Button>
      </div>
      {error && <p className="text-xs text-red-600 mt-1" data-testid="promo-error">{error}</p>}
    </div>
  );
};

export default PromoCodeField;
